module.exports = __webpack_public_path__ + "static/img/1638.2ac14f3.png";